import { render, staticRenderFns } from "./OdemeHatirlatma.vue?vue&type=template&id=33335a28&"
import script from "./OdemeHatirlatma.vue?vue&type=script&lang=js&"
export * from "./OdemeHatirlatma.vue?vue&type=script&lang=js&"
import style0 from "./OdemeHatirlatma.vue?vue&type=style&index=0&id=33335a28&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports